import styled from 'styled-components'

type StyledProps = {
  $status: string
  $isOwned?: boolean
}

const StyledCourseListItem = styled.a<StyledProps>`
  display: grid;
  gap: 24px;
  text-decoration: none;
  user-select: none;

  .course-thumbnail {
    padding-top: 56.25%;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    pointer-events: none;
    background-color: ${({ theme }) => theme.color.gray[100]};

    .course-pill {
      border-radius: 50rem;
      display: flex;
      align-items: center;
      height: 34px;
      padding: 0 14px;
      z-index: 1;
      font-size: 13px;
      font-weight: 600;
      overflow: hidden;
      box-shadow: 0 2px 6px rgb(0, 0, 0, 0.1), 0 0 10px rgb(0, 0, 0, 0.1);
    }

    .course-status {
      color: ${({ theme }) => theme.color.background};
      background-color: ${({ theme }) => theme.color.blue[500]};
      position: absolute;
      top: 16px;
      left: 16px;

      .progress-bar {
        position: absolute;
        height: 100%;
        left: 0;
        background-color: ${({ theme }) => theme.color.blue[700]};
      }

      .label {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        svg {
          height: 16px;
          stroke-width: 3px;
          margin-left: -6px;
          margin-right: 3px;
        }
      }

      ${({ $status, theme }) =>
        $status === 'Not Started' &&
        `
        background-color: ${theme.color.gray[500]};
      `}

      ${({ $status, theme }) =>
        $status === 'Completed' &&
        `
        background-color: ${theme.color.green[700]};

        .progress-bar {
          display: none;
        }
      `}
    }

    .course-stats {
      display: flex;
      align-items: center;
      position: absolute;
      left: 16px;
      bottom: 16px;
      z-index: 1;

      .course-stat {
        background-color: ${({ theme }) => theme.color.background};
        color: ${({ theme }) => theme.color.gray[600]};

        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      object-fit: cover;
    }
  }

  .course-details-container {
    display: grid;
    align-content: space-between;
    gap: 20px;
    justify-items: start;

    .course-title {
      font-weight: 600;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-align: left;
      -webkit-box-orient: vertical;
      line-height: 20px;
      color: ${({ theme }) => theme.color.gray[900]};
    }

    .course-description {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-align: left;
      -webkit-box-orient: vertical;
      margin-top: 8px;
      font-size: 13px;
      line-height: 18px;
      color: ${({ theme }) => theme.color.gray[600]};
    }

    .course-btn {
      height: 50px;
      display: flex;
      align-items: center;
      font-weight: 500;
      padding: 0 16px 0 14px;
      border-radius: 8px;
      transition: 0.2s;
      color: ${({ theme }) => theme.color.gray[800]};
      background-color: ${({ theme }) => theme.color.gray[100]};

      svg {
        height: 20px;
        stroke-width: 2.4px;
        margin-right: 10px;
      }

      ${({ $isOwned, theme }) =>
        !$isOwned &&
        `
        color: ${theme.color.gray[800]};
        box-shadow: inset 0 0 0 1px ${theme.color.gray[400]};
        background-color: ${theme.color.background};
      `}
    }
  }

  &:hover {
    .course-details-container .course-btn {
      background-color: ${({ theme }) => theme.color.gray[200]};
    }
  }

  @media (min-width: 600px) {
    grid-template-columns: 300px minmax(0, 1fr);

    .course-details-container {
      gap: 0;
    }
  }
`

export default StyledCourseListItem
